
import { mapActions, mapGetters } from 'vuex'
import LoleBackdrop from '~/components/common/lole-backdrop'
import Button from '~/components/buttons/Button'
import Price from '~/components/price/price'
import LolePicture from '~/components/picture/lole-picture'
import { isProductSellable } from '~/helpers/shopify/product'

export default {
  name: 'LoleCartConfirmation',
  components: {
    LoleBackdrop,
    Button,
    Price,
    LolePicture,
  },
  computed: {
    ...mapGetters({
      vxAddToCartNotification: 'notification/getAddToCartNotification',
      vxStory: 'common/getConfirmationStory',
    }),
  },
  watch: {
    vxAddToCartNotification() {
      this.getFocus()
    },
  },
  methods: {
    ...mapActions({
      vxCloseAllMobile: 'navigation/closeAllMobile',
      vxCloseAllDesktop: 'navigation/closeAllDesktop',
      vxGoToCheckout: 'product/goToCheckout',
    }),
    goToCheckout() {
      this.vxGoToCheckout(this.getGAIdSession())
    },
    isSellable() {
      return isProductSellable(this.$i18n.locale, this.$config)
    },
    getFocus() {
      if (this.vxAddToCartNotification)
        setTimeout(() => {
          this.$refs.closeButton.focus()
        }, 500)
    },
    closeAll() {
      this.vxCloseAllMobile()
      this.vxCloseAllDesktop()
    },
    getGAIdSession() {
      const ga = window[window.GoogleAnalyticsObject]
      if (ga && ga.getAll) {
        return ga.getAll()[0].get('linkerParam')
      } else return null
    },
  },
}
